<template lang="pug">
  .slider-container(v-if="slides && slides.length" ref="container" :style="{ height: `${height}px` }")
    easy-slider(
      v-if="width && height"
      animation="fade"
      :height="`${height}px`"
      :autoplay="true"
      :interval="5000"
      :stop-on-hover="true"
      :touch="false"
    )
      easy-slider-item.slide(v-for="(slide, i) in slides" :key="slide.id")
        Slide(:slide="slide" :max-width="width" :max-height="height")
</template>

<script>
import { Slider, SliderItem } from 'vue-easy-slider';
import { get, cloneDeep, debounce } from '@/helpers';
import Slide from './Slide';

export default {
    name: 'Slider',
    data() {
        return {
            width: undefined
        };
    },
    props: {
        // slides: {
        //     type: Array,
        //     default: () => [],
        // },
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Slide,
        EasySlider: Slider,
        EasySliderItem: SliderItem
    },
    computed: {
        settings() {
            return get(this.section, 'settings') || [];
        },
        slides() {
            let slides = this.section.contents || [];
            return cloneDeep(slides).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        },
        height() {
            let fr = 160;
            let height = 2 * fr;

            const config = this.settings.find(setting => setting.key === 'height');
            if (config && config.value) {
                switch (config.value) {
                    case 'small':
                        height = 1 * fr;
                        break;

                    case 'large':
                        height = 3 * fr;
                        break;
                }
            }

            return height;
        }
    },
    mounted() {
        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container);
                this.width = this.$refs.container.clientWidth;
                this.width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
            }
        };

        window.addEventListener('resize', debounce(calculateMaxWidth, 100));
        this.$nextTick(calculateMaxWidth);
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

.slider-container
  background: $skeletonColor
  ::v-deep
    .slider
      overflow: visible
      .slider-items
        overflow: hidden
    .slider-indicators
      bottom: -25px
    .slider-indicator-active
      background-color: var(--color-primary)
    .slider-indicator-icon
      margin: 0 .2rem
      width: 8px
      height: 8px
</style>
